import { t } from '@/i18n/utils'
import { RECHARGE_TYPE_NAME } from '@/utils/enum'

/**
 * 充值记录页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const rechargeCommonConfig = {
  texts: {
    /** 页面标题（NovelMello 顶栏常驻标题使用；其它品牌顶栏不展示标题，不受影响） */
    get pageTitle() { return t('TransactionHistory') },
    get noRecord() { return t('NoRecord') },
    // 与 en.json 不完全匹配（'Discounted Vip({0})' 带参数）
    get discountedVip() { return t('discountedVip') },
    get unlimitedVip() { return t('UnlimitedVip') },
    get coins() { return t('Coins') },
    get expireOn() { return t('ExpireOn') },
    get noMore() { return `${t('NoMore')} ~` },
    get loading() { return `${t('Loading')}...` },

    /**
     * 充值记录类型（基于 RECHARGE_TYPE_NAME 的 key）
     * 注意：RECHARGE_TYPE_NAME.label 现在存的是 i18n key
     */
    rechargeTypeLabel(type: number) {
      const i18nKey = RECHARGE_TYPE_NAME.getItemByValue(type)?.label
      return i18nKey ? t(i18nKey) : ''
    },
  },
}
